import { colors } from '../common/colors';
import { palette as defaultPalette } from '../common/palette';

export const secondary = {
    main: colors.themes.green.primary,
    contrastText: colors.black,
};

export const common = {
    ...colors,
    ...colors.themes.green,
};

export const palette = {
    ...defaultPalette,
    secondary,
    common,
    action: {
        active: colors.themes.green.primaryLightSelected,
        hover: colors.themes.green.primaryLightHover,
        selected: colors.themes.green.primaryLightSelected,
        focus: colors.themes.green.primaryLightSelected,
    },
};
